function ValidateEmail(input) {
    var validRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    if (input.match(validRegex)) {
      return true;
    } else {
      return false;
    }
  }

  function reFormatDate(){
     const expireDate = new Date();
     return expireDate.toLocaleDateString();
  }

  function getGiftCardBalance(){

    const email = document.querySelector('#gift-card-email');
    const spinner = document.querySelector('#lds-ring');
    const code = document.querySelector('#gift-card-code');
    const no_result = document.querySelector('#gift-card-no-result');
    const errorCode = document.querySelector('#gift-card-errors-code');
    const errorEmail = document.querySelector('#gift-card-errors-email');
    const gift_card_balance = document.querySelector('#gift-card-balance');
    const gift_card_date = document.querySelector('#gift-card-date');
    const shopUrl = document.querySelector("[data-shopurl]")
    let error = false;

    if(!email.value || !ValidateEmail(email.value)){
      email.classList.add("error-inputs");
      errorEmail.style.display = "block";
      gift_card_balance.style.display = "none";
      gift_card_date.style.display = "none";
      errorCode.style.display = "none";
      no_result.style.display = "none";
      code.classList.remove("error-inputs");
      error = true;
    }

    if((code.value.length!== 4) && !error){
      code.classList.add("error-inputs");
      errorCode.style.display = "block";
      gift_card_balance.style.display = "none";
      gift_card_date.style.display = "none";
      errorEmail.style.display = "none";
      no_result.style.display = "none";
      email.classList.remove("error-inputs");
      error = true;
    }

    if(!error){
      spinner.style.display = "inline-block";
      const response = fetch(shopUrl.dataset.shopurl+"/apps/spapp/getCustomerGiftCards", {
        method: "POST", 
        headers: {
          "Content-Type": "application/json",
        }, 
        body: JSON.stringify({email : email.value,code : code.value}),
      }).then(result => result.json()
       ).then(data => {
         if(!data || data?.length === 0)
          { 
          no_result.style.display = "block";
          gift_card_balance.style.display = "none";
          gift_card_date.style.display = "none";

         }
         else{
          gift_card_balance.querySelector('b').innerHTML = data[0].balance + '€';
          data[0].expires_on ? gift_card_date.querySelector('b').innerHTML =  reFormatDate(data[0].expires_on) : null;
          gift_card_balance.style.display = "inherit";
          gift_card_date.style.display = "inherit";
          no_result.style.display = "none";

        }

        spinner.style.display = "none";
        errorEmail.style.display = "none";
        errorCode.style.display = "none";
        email.classList.remove("error-inputs");
        code.classList.remove("error-inputs");
      }
    )
    
    }


  
  }
  
  